export default "__VITE_ASSET__Dd0iQAvQ__"